/**
 @abstract
 */
class Provider {
    constructor() {
        if (this.constructor === Provider) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        this.player = false;
    }

    playerExist() {
        return this.player;
    }

    playerScriptSrc() {
        throw new Error("Method 'playerScriptSrc()' must be implemented.");
    }

    playerScriptId() {
        throw new Error("Method 'playerScriptId()' must be implemented.");
    }

    createPlayerBox() {
        throw new Error("Method 'createPlayerBox()' must be implemented.");
    }

    play() {
        throw new Error("Method 'play()' must be implemented.");
    }

    pause() {
        throw new Error("Method 'pause()' must be implemented.");
    }

    loadVideoScripts(callbackFunction = {}) {
        const tag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];
        tag.src = this.playerScriptSrc();
        tag.id = this.playerScriptId();
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        if (typeof callbackFunction === 'function') {
            tag.onload = () => callbackFunction();
        }
    }
}

export default Provider;
